import TubularSVG from "./svg/TubularSVG";
import TableTopSVG from "./svg/TableTopSVG";
import BoltSVG from "./svg/BoltSVG";
import CrossSVG from "./svg/CrossSVG";

const HomeDevices = () => {
  return (
    <div className="devices">
        <div className="devices__box">
            <div className="devices__row">
                <p className="devices__title">Devices</p>
                <p className="devices__last-updated">Last Updated: 3 minutes ago</p>
            </div>
            <div className="devices__row">

            <table className="devices__table">
                <thead>
                <tr className="devices__table__header">
                    <th className="devices__table__title devices__table--left">Name</th>
                    <th className="devices__table__title devices__table--center">Online Status</th>
                    <th className="devices__table__title devices__table--center">Charge</th>
                    <th className="devices__table__title devices__table--center">Signal</th>
                    <th className="devices__table__title devices__table--center">Contact</th>
                    <th className="devices__table__title devices__table--center">Last Donation</th>
                    <th className="devices__table__title devices__table--center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr className="devices__table__row">
                    <td className="devices__table__name devices__table--left"><TableTopSVG className="devices__table__tabletop-icon"/>London Central Cafe</td>
                    <td className="devices__table--center"><span className="devices__table__online-badge devices__table__online-badge--offline">Offline</span></td>
                    <td className="devices__table__charge devices__table--center">20%</td>
                    <td className="devices__table__signal devices__table--center"><CrossSVG className="devices__table__cross-icon"/></td>
                    <td className="devices__table__contact devices__table--center">John Smith</td>
                    <td className="devices__table__last-donation devices__table--center">5th Sep 2019 - 5:59pm</td>
                    <td className="devices__table--center"><a className="devices__table__edit" href="/">Edit</a></td>
                </tr>
                <tr className="devices__table__row">
                    <td className="devices__table__name devices__table--left"><TubularSVG className="devices__table__tubular-icon"/>Liverpool Street Charity Zone #1</td>
                    <td className="devices__table--center"><span className="devices__table__online-badge devices__table__online-badge--online">Online</span></td>
                    <td className="devices__table__charge devices__table--center"><span className="devices__table__charge-box">100%<BoltSVG className="devices__table__bolt-icon"/></span></td>
                    <td className="devices__table__signal devices__table--center">4/5</td>
                    <td className="devices__table__contact devices__table--center">John Smith</td>
                    <td className="devices__table__last-donation devices__table--center">10th Sep 2019 - 8:33am</td>
                    <td className="devices__table--center"><a className="devices__table__edit" href="/">Edit</a></td>
                </tr>
                <tr className="devices__table__row">
                    <td className="devices__table__name devices__table--left"><TubularSVG className="devices__table__tubular-icon"/>Liverpool Street Charity Zone #2</td>
                    <td className="devices__table--center"><span className="devices__table__online-badge devices__table__online-badge--online">Online</span></td>
                    <td className="devices__table__charge devices__table--center">45%</td>
                    <td className="devices__table__signal devices__table--center">5/5</td>
                    <td className="devices__table__contact devices__table--center">John Smith</td>
                    <td className="devices__table__last-donation devices__table--center">10th Sep 2019 - 10:35am</td>
                    <td className="devices__table--center"><a className="devices__table__edit" href="/">Edit</a></td>
                </tr>
                <tr className="devices__table__row">
                    <td className="devices__table__name devices__table--left"><TableTopSVG className="devices__table__tabletop-icon"/>Liverpool Street Handheld Team #1</td>
                    <td className="devices__table--center"><span className="devices__table__online-badge devices__table__online-badge--online">Online</span></td>
                    <td className="devices__table__charge devices__table--center">86%</td>
                    <td className="devices__table__signal devices__table--center">3/5</td>
                    <td className="devices__table__contact devices__table--center">Sarah Williams</td>
                    <td className="devices__table__last-donation devices__table--center">10th Sep 2019 - 11:26am</td>
                    <td className="devices__table--center"><a className="devices__table__edit" href="/">Edit</a></td>
                </tr>
                <tr className="devices__table__row">
                    <td className="devices__table__name devices__table--left"><TableTopSVG className="devices__table__tabletop-icon"/>Liverpool Street Handheld Team #2</td>
                    <td className="devices__table--center"><span className="devices__table__online-badge devices__table__online-badge--online">Online</span></td>
                    <td className="devices__table__charge devices__table--center">92%</td>
                    <td className="devices__table__signal devices__table--center">2/5</td>
                    <td className="devices__table__contact devices__table--center">Dave Jones</td>
                    <td className="devices__table__last-donation devices__table--center">10th Sep 2019 - 9:21am</td>
                    <td className="devices__table--center"><a className="devices__table__edit" href="/">Edit</a></td>
                </tr>
                </tbody>
            </table>
        </div>
      </div>
    </div>
  );
};

export default HomeDevices;
